import Model from '../Model';
import {OrmConfig} from "@/pcm/types/vuex/OrmConfig";
import User from "@/pcm/store/models/User";
import Country from "@/pcm/store/models/Country";
import ClientPaymentInformation from "@/pcm/store/models/ClientPaymentInformation";
import ClientContract from "@/pcm/store/models/ClientContract";
import NewClient from "@/pcm/store/models/NewClient";
import SubscriptionClient from "@/pcm/store/models/SubscriptionClient";

export default class SubscriptionClientActivity extends Model {
    static entity = 'subscription_client_activities';

    static apiConfig: OrmConfig = {
        model: this.entity,
        name_prop: 'status',
    };

    static fields() {
        return {
            id: this.uid(),
            subscription_client_id: this.attr(null),
            status: this.string(''),
            ended_at: this.string(null).nullable(),
            created_at: this.string(''),
            updated_at: this.string(''),

            // Relations
            subscriptionClient: this.belongsTo(SubscriptionClient, 'subscription_client_id'),
        }
    }

    declare id: number;
    declare subscription_client_id: number;
    declare status: string;
    declare ended_at: string;

    declare subscriptionClient: SubscriptionClient | null;
}
